module.exports = __webpack_public_path__ + "img/phone.91f3f9f4.png";